// extracted by mini-css-extract-plugin
module.exports = {"header":"_30ZcW","message":"_2Zayn"};